import type { DocumentsAndRequestsFeatureConfig } from '../type';

export const documentsAndRequests: Partial<DocumentsAndRequestsFeatureConfig> = {
    documentsPackageDownload: true,
    operationAgnosticSigning: true,
    temporarilyBypassCapabilities: true,
    signingAlwaysVisible: true,
    caseConfidentialFilterVisible: true,
    overviewFilterCaseStatus: true,
    overviewFilterCaseStatuses: [
        'FOR_SIGNING',
        'SIGNED',
        'COSIGNING',
        'REJECTED',
        'FOR_DISPLAY',
        'DISPLAYED',
        'CANCELLED',
        'EXPIRED',
    ],
    overviewFilterCaseCategory: true,
    cacheDuration: 30000,
};
